@let gridData = $gridData();
@let T = gridData.data;

<unity-grid-shared
  gridTitle="Business Partner Roles"
  [gridData]="gridData"
  [gridError]="$gridError()"
  [gridLoading]="$gridLoading()"
  [defaultSort]="defaultSort"
  (dataQueryEvent)="onDataQuery($event)">
  <kendo-grid-column field="agency_name" title="Business Partner Name">
    <ng-template let-userRole kendoGridCellTemplate [unityTyped]="T">
      <unity-link-gridcell-shared [displayText]="userRole.agency_name" [link]="['/business-partner', userRole.agency_id]" />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="name" title="Role at Business Partner">
    <ng-template let-userRole kendoGridCellTemplate [unityTyped]="T">
      <unity-link-gridcell-shared [displayText]="userRole.name" [link]="['/business-partner', userRole.agency_id, 'role', userRole.id]" />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="current_state.name" title="Status">
    <ng-template let-userRole kendoGridCellTemplate [unityTyped]="T">
      <unity-chip-workflow-state-shared [name]="userRole.current_state_name" [value]="userRole.current_state_enum_value" />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column title="Actions" class="align-center">
    <ng-template let-userRole kendoGridCellTemplate [unityTyped]="T">
      <unity-action-shared [action]="changeRoleAction" [disabled]="false" (clickEvent)="openRoleChangeDialog(userRole)" />
      <unity-gridcell-user-role-workflow-actions-shared [userRole]="userRole" (workflowEvent)="doTransition($event)" />
    </ng-template>
  </kendo-grid-column>
</unity-grid-shared>

@let editingUserRole = $editingRole();
@if (!!editingUserRole) {
  <unity-dialog-edit-user-role-shared
    *unityAuthorize="'UserRole:Update'"
    [userRole]="editingUserRole"
    (changeRoleEvent)="doRoleChange($event)"
    (closeEvent)="closeRoleChangeDialog()" />
}
